import { render } from "./AppCheckbox.vue?vue&type=template&id=b21ffe88"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"

import "./AppCheckbox.vue?vue&type=style&index=0&id=b21ffe88&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__